export function slugify(s) {
  if(!s) return 'Slugify did not receive anything.'
  return s.replace(/\s+/g, '-')
          .replace(/[^\w-]+/g, '')
          .replace(/--+/g, '-')
          .replace(/^-+/, '')
          .replace(/-+$/, '')
          .toLowerCase()
}


// WEBPACK FOOTER //
// ./src/libs/utils.js